import React from 'react';
import PropTypes from 'prop-types';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';
import { missingLaunchSettings } from '../../config/site';
import './PublicLayout.css';

// In development only: a reminder of the business details that still have to be filled in before launch.
const LaunchChecklist = () => {
  if (process.env.NODE_ENV === 'production') return null;
  const missing = missingLaunchSettings();
  if (missing.length === 0) return null;

  return (
    <div className="launch-checklist" role="note">
      <strong>Development note (hidden on the live site):</strong> these business details are not set yet, so the pages
      leave them out: {missing.join(', ')}. See frontend/.env.example.
    </div>
  );
};

// The frame around every public page: skip link, header, one main landmark, footer.
const PublicPage = ({ children, className = '' }) => (
  <div className={`public-page ${className}`.trim()}>
    <a href="#main" className="skip-link">Skip to content</a>
    <LaunchChecklist />
    <PublicHeader />
    <main id="main" tabIndex={-1}>{children}</main>
    <PublicFooter />
  </div>
);

PublicPage.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default PublicPage;
